import { SearchFiltersProvider } from 'context/SearchFilters.context';
import classes from './SupplierActivityList.module.scss';
import { Box, Grid, Group, Title } from '@mantine/core';
import BackButton from 'components/BackButton/BackButton';
import { useRouter } from 'next/router';
import React, { ReactNode } from 'react';
import { ActivitySearchResult } from 'types';
import { Supplier } from 'interfaces';
import { useMediaQuery } from '@mantine/hooks';
import NewActivityCard from 'components/NewActivityCard/NewActivityCard';

interface ISupplierActivitiesProps {
  activities: ActivitySearchResult[] | null;
  error: boolean;
  rawError?: string;
  totalActivitiesCount: number;
  supplier: Supplier | null;
  page: string;
  categoryName?: string;
  categorySlug?: string;
  children: ReactNode;
}

const SupplierActivityList: React.FC<ISupplierActivitiesProps> = (props) => {
  const { activities, supplier, categoryName, children } = props;

  const isMobile = useMediaQuery('(max-width: 768px)');

  const router = useRouter();

  return (
    <SearchFiltersProvider>
      <div className={classes.searchResultsPageWrapper}>
        <div className={classes.supplierActivitiesContainer}>
          <Box className={classes.headerWrapper}>
            <Box className={classes.iconMenuWrapper}>
              <BackButton
                onClick={() => {
                  router.push(`/supplier/${supplier?.slug}`);
                }}
              />
            </Box>

            <Title
              style={{
                color: 'var(--mantine-colors-blue-8)',
              }}
              order={3}
            >
              {categoryName ? `${categoryName} activities` : 'Activities'} for
              <Title className={classes.supplierTitle} order={5}>
                {supplier?.name}
              </Title>
            </Title>
          </Box>

          <div>
            <Grid
              gutter="xl"
              columns={2}
              justify={isMobile ? 'center' : 'flex-start'}
              className={classes.grid}
              w="100%"
            >
              {activities &&
                activities.map((activity) => (
                  <Grid.Col
                    key={activity.id}
                    span={{ xs: 2, sm: 1 }}
                    maw={'100%'}
                    ml={isMobile ? 'lg' : 0}
                  >
                    <NewActivityCard activity={activity} />
                  </Grid.Col>
                ))}
            </Grid>
          </div>
          <Group justify="center" className={classes.paginationWrapper}>
            {children}
          </Group>
        </div>
      </div>
    </SearchFiltersProvider>
  );
};

export default SupplierActivityList;
